import { render, staticRenderFns } from "./ponds.vue?vue&type=template&id=5154d785&scoped=true"
import script from "./ponds.vue?vue&type=script&lang=js"
export * from "./ponds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5154d785",
  null
  
)

export default component.exports